import * as types from "../constants/actionTypes";
import { LOCATION_CHANGE } from "react-router-redux";
import initialState from "./initialState";

export default (state = initialState.registrationSubmitingStatus, action) => {
  switch (action.type) {
    case types.SET_REGISTRATION_DATA:
      return {
        error: false,
        loading: false,
        succeed: true
      };
    //todo check when should reset model
    case LOCATION_CHANGE:
      return {
        error: false,
        loading: false,
        succeed: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/registrationSubmitingStatus.js